import { render, staticRenderFns } from "./dashboardSkeleton.vue?vue&type=template&id=0a28eae6"
import script from "./dashboardSkeleton.vue?vue&type=script&lang=js"
export * from "./dashboardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports